import PageHeader from "../../../Layout/PageHeader";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useEffect, useState } from "react";
import FormButton from "../../../Components/Buttons/FormButton";
import { bomBasicInformationType } from "./Bom.type";
import InputFiled from "../../../Components/FormTag/InputFiled";
import Tabs from "../../../Shared/Tab/Tab";
import {
  ALPHANUM_REGEX,
} from "../../../Shared/Helper/Constant";
import { PATTERN_ERR_MSG } from "../../../Shared/Helper/ValidationMessage";
import {
  BomAttributeData
} from "../../../Data/BomMaintainanceData";

export default function BomAttributeEdit() {
  const navigate = useNavigate();
  const [itemsBasicData, setItemsBasicData] = useState<bomBasicInformationType>(
    new bomBasicInformationType()
  );
  const pageName = `Kitting`;
  const [isChecked, setIsChecked] = useState(true);
  const [isShowCanvas, setShowCanvas] = useState(false);


  const {
    register,
    setValue,
    formState: { errors },
  } = useForm<bomBasicInformationType>({
    defaultValues: itemsBasicData,
  });

  useEffect(() => {
    setValue('defaultZone', BomAttributeData[0].defaultZone);
    setValue('minStockLevel', BomAttributeData[0].minStockLevel);
    setValue('maxStockLevel', BomAttributeData[0].maxStockLevel);
    setValue('suggStockLevel', BomAttributeData[0].suggStockLevel);
    setValue('itempopularity', BomAttributeData[0].itempopularity);
    setValue('FLMethod', BomAttributeData[0].FLMethod);
    setValue('description', BomAttributeData[0].description);
    setValue('countryOrigin', BomAttributeData[0].countryOrigin);
    setValue('shelfLife', BomAttributeData[0].shelfLife);
    setValue('shipLife', BomAttributeData[0].shipLife);
  }, [setValue, BomAttributeData]);

 

  const backNavigate = () => {
    return navigate(`/inventory/assembly/kitting/details/{id}`);
  };

  const handleClose = () => {
    backNavigate();
  };

  type CheckboxStates = {
    [key: string]: boolean; // This allows dynamic string keys
  };
  const [checkboxStates, setCheckboxStates] = useState<CheckboxStates>({
    serial: true,
    tag: true,
    lot: true,
    batch: true,
    scannableItem: true,
  });
  const handleCheckboxChange = (key: keyof CheckboxStates) => {
    setCheckboxStates((prevState) => ({
      ...prevState,
      [key]: !prevState[key],
    }));
  };

  const tabs = [
    {
      order: 0,
      label: "Basic Information",
      content: (
        <>
        </>
      ),
      visibility: true,
      status: true,
    },
    {
      order: 1,
      label: "Attribute",
      content: (
        <>
        </>
      ),
      visibility: true,
      status: false,
    },
    {
      order: 2,
      label: "Configure Kit",
      content: (
        <>
        </>
      ),
      visibility: true,
      status: false,
    },
    {
      order: 3,
      label: "User defined Field",
      content: (
        <>
        </>
      ),
      visibility: true,
      status: false,
    }
  ];

  return (
    <div>
      <PageHeader
       addUrl="/inventory/assembly/kitting/create"
       listUrl="/inventory/assembly/kitting/details/{id}"
        viewType={true}
        isHistoryEnabled={true}
      />
      <div className="clearfix"></div>
      <h5 className="text-start mt-1 mb-3">{pageName}</h5>
      <div>
        <div>
        <Tabs
          tabs={tabs}
          isCheckbox={true}
          activeTabClass="d-flex flex-column h-100"
          tabLabelClass="d-flex flex-column h-100"
        />
          <div className="mb-2 mt-1 p-4 h-100 bg-white rounded">
            <div className="p-4 d-flex flex-wrap">
              <div className="mb-5 col-2">
                <div>
                  <label className="fw-medium">Serial #</label>
                </div>
                <div className="fs-15">
                  <div className="form-check form-switch sidebar-toggler mt-auto py-2 mt-1">
                    <input
                      className="form-check-input toggle-button-size"
                      type="checkbox"
                      role="switch"
                      id="flexSwitchCheckChecked1"
                      checked={checkboxStates.serial}
                      onChange={() => handleCheckboxChange('serial')}
                    />
                  </div>
                </div>
              </div>
              <div className="mb-5 col-2">
                <div>
                  <label className="fw-medium">Tag #</label>
                </div>
                <div className="form-check form-switch sidebar-toggler mt-auto py-2 mt-1">
                  <input
                    className="form-check-input toggle-button-size"
                    type="checkbox"
                    role="switch"
                    id="flexSwitchCheckChecked2"
                    checked={checkboxStates.tag}
                    onChange={() => handleCheckboxChange('tag')}
                  />
                </div>
              </div>
              <div className="mb-5 col-2">
                <div>
                  <label className="fw-medium">Lot #</label>
                </div>
                <div className="form-check form-switch sidebar-toggler mt-auto py-2 mt-1">
                  <input
                    className="form-check-input toggle-button-size"
                    type="checkbox"
                    role="switch"
                    id="flexSwitchCheckChecked3"
                    checked={checkboxStates.lot}
                    onChange={() => handleCheckboxChange('lot')}
                  />
                </div>
              </div>
              <div className="mb-5 col-2">
                <div>
                  <label className="fw-medium">Batch #</label>
                </div>
                <div className="fs-15">
                  <div className="form-check form-switch sidebar-toggler mt-auto py-2 mt-1">
                  <input
                    className="form-check-input toggle-button-size"
                    type="checkbox"
                    role="switch"
                    id="flexSwitchCheckChecked4"

                    checked={checkboxStates.batch}
                    onChange={() => handleCheckboxChange('batch')}
                  />
                </div></div>
              </div>
              <div className="mb-5 col-3">
                <div>
                  <label className="fw-medium">Scannable Item</label>
                </div>
                <div className="fs-15">
                  <div className="form-check form-switch sidebar-toggler mt-auto py-2 mt-1">
                  <input
                    className="form-check-input toggle-button-size"
                    type="checkbox"
                    role="switch"
                    id="flexSwitchCheckChecked5"
                    checked={checkboxStates.scannableItem}
                    onChange={() => handleCheckboxChange('scannableItem')}
                  />
                </div></div>
              </div>

              <div className="mb-5 col-2">
                <div>
                  <label className="fw-medium">Default Zone</label>
                </div>
                <div className="mt-1 vw-12">
                  <InputFiled
                    tabIndex={0}
                    autoFocus={true}
                    type="text"
                    register={register}
                    name="defaultZone"
                    errors={errors.itemCode}
                    className="form-control"
                    placeholder="Enter Code"
                    required={true}
                    pattern={{ type: ALPHANUM_REGEX, message: PATTERN_ERR_MSG }}
                  />
                </div>
              </div>

              <div className="mb-5 col-2">
                <div>
                  <label className="fw-medium">Min Stock Level</label>
                </div>
                <div className="mt-1 vw-12">
                  <InputFiled
                      tabIndex={1}
                      autoFocus={true}
                      type="text"
                      register={register}
                      name="minStockLevel"
                      errors={errors.itemCode}
                      className="form-control"
                      placeholder="Enter Code"
                      required={true}
                      pattern={{ type: ALPHANUM_REGEX, message: PATTERN_ERR_MSG }}
                    />
                </div>
              </div>

              <div className="mb-5 col-2">
                <div>
                  <label className="fw-medium">Max Stock Level</label>
                </div>
                <div className="mt-1 vw-12">
                  <InputFiled
                    tabIndex={2}
                    autoFocus={true}
                    type="text"
                    register={register}
                    name="maxStockLevel"
                    errors={errors.itemCode}
                    className="form-control"
                    placeholder="Enter Code"
                    required={true}
                    pattern={{ type: ALPHANUM_REGEX, message: PATTERN_ERR_MSG }}
                  />
                </div>
              </div>
              <div className="mb-5 col-2">
                <div >
                  <label className="fw-medium">Sugg. Stock Level</label>
                </div>
                <div className="mt-1 vw-12">
                  <InputFiled
                    tabIndex={3}
                    autoFocus={true}
                    type="text"
                    register={register}
                    name="suggStockLevel"
                    errors={errors.itemCode}
                    className="form-control"
                    placeholder="Enter Code"
                    required={true}
                    pattern={{ type: ALPHANUM_REGEX, message: PATTERN_ERR_MSG }}
                  />
                </div>
              </div>
              <div className="mb-5 col-3">
                <div>
                  <label className="fw-medium">Item Popularity</label>
                </div>
                <div className="mt-1 vw-12">
                  <InputFiled
                    tabIndex={4}
                    autoFocus={true}
                    type="text"
                    register={register}
                    name="itempopularity"
                    errors={errors.itemCode}
                    className="form-control"
                    placeholder="Enter Code"
                    required={true}
                    pattern={{ type: ALPHANUM_REGEX, message: PATTERN_ERR_MSG }}
                  />
                </div>
              </div>
              <div className="mb-5 col-2">
                <div>
                  <label className="fw-medium">FIFO/LIFO Method</label>
                </div>
                <div className="vw-12 mt-1">
                  <InputFiled
                    tabIndex={5}
                    autoFocus={true}
                    type="text"
                    register={register}
                    name="FLMethod"
                    errors={errors.itemCode}
                    className="form-control"
                    placeholder="Enter Code"
                    required={true}
                    pattern={{ type: ALPHANUM_REGEX, message: PATTERN_ERR_MSG }}
                  />
                </div>
              </div>
              <div className="mb-5 col-2">
                <div>
                  <label className="fw-medium">Description</label>
                </div>
                <div className="vw-12 mt-1">
                  <InputFiled
                    tabIndex={6}
                    autoFocus={true}
                    type="text"
                    register={register}
                    name="description"
                    errors={errors.itemCode}
                    className="form-control"
                    placeholder="Enter Code"
                    required={true}
                    pattern={{ type: ALPHANUM_REGEX, message: PATTERN_ERR_MSG }}
                  />
                </div>
              </div>

              <div className="mb-5 col-2">
                <div>
                  <label className="fw-medium">Country Of Origin</label>
                </div>
                <div className="vw-12 mt-1">
                  <InputFiled
                    tabIndex={7}
                    autoFocus={true}
                    type="text"
                    register={register}
                    name="countryOrigin"
                    errors={errors.itemCode}
                    className="form-control"
                    placeholder="Enter Code"
                    required={true}
                    pattern={{ type: ALPHANUM_REGEX, message: PATTERN_ERR_MSG }}
                  />
                </div>
              </div>
              <div className="mb-5 col-2">
                <div>
                  <label className="fw-medium">Shelf Life</label>
                </div>
                <div className="vw-12 mt-1">
                  <InputFiled
                    tabIndex={8}
                    autoFocus={true}
                    type="text"
                    register={register}
                    name="shelfLife"
                    errors={errors.itemCode}
                    className="form-control"
                    placeholder="Enter Code"
                    required={true}
                    pattern={{ type: ALPHANUM_REGEX, message: PATTERN_ERR_MSG }}
                  />
                </div>
              </div>

              <div className="mb-5 col-3">
                <div>
                  <label className="fw-medium">Ship Life</label>
                </div>
                <div className="vw-12 mt-1">
                  <InputFiled
                    tabIndex={9}
                    autoFocus={true}
                    type="text"
                    register={register}
                    name="shipLife"
                    errors={errors.itemCode}
                    className="form-control"
                    placeholder="Enter Code"
                    required={true}
                    pattern={{ type: ALPHANUM_REGEX, message: PATTERN_ERR_MSG }}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="mt-auto bg-white rounded py-3">
            <div className="d-flex flex-row-reverse">
              <div className="d-flex flex-row-reverse">
                <FormButton
                  tabIndex={13}
                  className="sph-btn me-4"
                  handleClick={() => handleClose()}
                >
                  Submit
                </FormButton>
                <FormButton
                  tabIndex={14}
                  className="sph-btn sph-shift me-4"
                  handleClick={() => handleClose()}
                >
                  Cancel
                </FormButton>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}


